import { CSSObject } from '@chakra-ui/react';

export const Accordion: CSSObject = {
  border: 'none',
  overflow: 'hidden',
  borderRadius: 'md',

  '.chakra-accordion__item': {
    mb: '2',
    bg: 'alpha.500',
    boxShadow:
      '0px 0px 0px 1px rgba(55, 140, 255, 0.50) inset, 0px 4px 10px 0px rgba(0, 0, 0, 0.30)',
    borderRadius: 'md',
    border: 'none',
  },

  '.chakra-accordion__panel': {
    color: 'white',
    '.chakra-text': {
      _first: {
        color: 'white',
      },
      _notFirst: {
        borderRadius: 'base',
        bg: 'alpha.800',
        color: 'whiteAlpha.700',
        opacity: '0.5',
        border: 'none',
      },
    },
  },
};

export const AccordionHeader: CSSObject = {
  color: 'white',
  transitionDuration: 'normal',
  transitionProperty: 'common',

  '.chakra-accordion__icon': {
    boxSize: '6',
    color: 'beta.500',
  },
};

export const OverviewPromotionsPanel: CSSObject = {
  color: 'white',

  '.chakra-checkbox__control': {
    borderRadius: 'xs',
    border: '1px solid black',
  },
};

export const AccordionHeaderLogOut: CSSObject = {
  borderColor: 'alpha.500',
  boxShadow:
    '0px 0px 0px 1px rgba(55, 140, 255, 0.50) inset, 0px 4px 10px 0px rgba(0, 0, 0, 0.30)',
  color: 'white',
  borderRadius: 'md',
  fontFamily: 'Staatliches',
  fontSize: 'sm',
  _hover: {
    bg: 'alpha.700',
    color: 'white',
  },
  _focus: {
    bg: 'alpha.700',
    color: 'white',
  },
  _last: {
    mb: '2',
  },
};

export const IconPerson: CSSObject = {
  boxSize: ['5', null, '6'],
  color: 'white',
  mr: '1.5',
};

export const TextAccordion: CSSObject = {
  fontSize: 'sm',
  fontWeight: 'normal',
  fontFamily: 'Staatliches',
  mr: 'auto',
};

export const FlexContactToChange: CSSObject = {
  alignItems: 'center',
  justifyContent: 'center',
  bg: 'beta.500',
  borderRadius: 'base',
  boxShadow: '0px 3px 5px 0px rgba(0, 0, 0, 0.20)',
  fontSize: 'xs',
  fontWeight: 'bold',
  gap: '1',
  p: '2',
  '.chakra-text': {
    color: 'var(--bc-colors-beta-800) !important',
  },
  '.chakra-icon': {
    color: 'beta.800',
  },
};

export const OverviewAccordionItem: CSSObject = {
  '.chakra-checkbox__label': {
    color: 'white',
  },
  border: 'none',
  bg: 'alpha.500',
  mb: '0',
  boxShadow:
    '0px 0px 0px 1px rgba(55, 140, 255, 0.50) inset, 0px 4px 10px 0px rgba(0, 0, 0, 0.30)',
};
